import { Inject, Injectable } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { APP_SETTINGS, AppSettings } from "app/app.settings";

@Injectable({
    providedIn: "root"
})

export class NavigatorService {
    constructor(@Inject(APP_SETTINGS) private env: AppSettings, private router: Router) { }

    parseLink(link: string, ...args: any[]) {
        let newlink = this.env.links[link];
        for (let i = 0; i < args.length; i++) {
            const s = `{${i}}`;
            newlink = newlink.replace(s, "" + args[i]);
        }
        return newlink;
    }

    public navigateTo(link: string, ...args: any[]) {
        link = this.parseLink(link, ...args);
        if (link[0] == "[" && link[link.length - 1] == "]") {
            const p = JSON.parse(link);
            this.router.navigate(p);
            return;
        }

        window.open(link, "_self");
    }

    public navigateToNewWindow(link: string, ...args: any[]) {
        link = this.parseLink(link, ...args);
        if (link[0] == "[" && link[link.length - 1] == "]") {
            const p = JSON.parse(link);
            this.router.navigate(p);
            return;
        }

        window.open(link, "_blank");
    }

    // Map to router
    public navigate(commands: any[], extras?: NavigationExtras | undefined): Promise<boolean> {
        return this.router.navigate(commands, extras);
    }

}
